<template>
    <div>
        <Overlay :show="show" z-index="3000" :lock-scroll="false">
            <div class="video-wrapper">
                <div class="closs-icon" @click="closeVideo">
                    <Icon name="cross" size="2rem" />
                </div>
                <video ref="videoRef" class="video-body" controls :src="videoUrl"
                    :aria-label="'视频播放器'">
                    <track kind="captions" src="data:text/vtt;base64," srclang="en" label="No captions">
                </video>
            </div>
        </Overlay>
    </div>
</template>

<script setup>
import { defineProps, ref } from 'vue'
import { Overlay, Icon } from 'vant';
const props = defineProps({
    show: {
        type: Boolean,
        default: false
    },
    videoUrl: {
        type: String,
        default: ''
    },
    posterUrl: {
        type: String,
        default: ''
    }
})
const emit = defineEmits(['closeVideo'])
const videoRef = ref(null)
const closeVideo = () =>{
    videoRef.value.pause();
    emit('closeVideo')
}


</script>

<style lang='scss' scoped>
$breakpoint-mobile: 767px;
$padding-desktop: 32px;
$padding-mobile: 24px;

@mixin mobile {
  @media (max-width: #{$breakpoint-mobile}) {
    @content;
  }
}

@mixin desktop {
  @media (min-width: #{$breakpoint-mobile + 1}) {
    @content;
  }
}

.video-wrapper{
    background-color: #fff;
    box-sizing: border-box;
    height: 100%;

    @include desktop {
        padding: $padding-desktop*3 $padding-desktop*2 $padding-desktop*2;
    }
    
    @include mobile {
        padding: $padding-mobile*3 0 0;
    }
    
    .closs-icon{
        cursor: pointer;
        position: absolute;
        transition: transform 0.3s ease-in-out;

        &:hover {
            transform: rotate(90deg);
            color: #000;
        }
        
        @include desktop {
            top: $padding-desktop;
            right: $padding-desktop;
        }
        
        @include mobile {
            top: $padding-mobile;
            right: $padding-mobile;
        }
    }
    .video-body{
        width: 100%;
        height: 100%;
    }
}

</style>